import { useMutation, useQuery } from "@tanstack/react-query";
import axiosBaseURL from "..";
import { useAuth, AuthContextValue } from "../../providers/AuthProvider";

export const useEntitlementByContractId = (id?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["useEntitlementByContractId", id],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(
        `/redemption/getEntitlements/${id}`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );

      return result;
    },
  });
};

export const useRedemption = () => {
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (data: any) => {
      const result = await axiosBaseURL.post(`/redemption/redeem`, data, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useRedemptionNotification = () => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["get all notification"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/redemption/notification`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
          Authorization: authString,
        },
      });

      return result;
    },
  });
};

export const useSeen = () => {
  const { refetch } = useRedemptionNotification();
  const { user } = useAuth() as AuthContextValue;

  return useMutation({
    mutationFn: async (redemption: any) => {
      const result = await axiosBaseURL.put(
        `/redemption/notification/seen/${redemption.id}`,
        {},
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );
      refetch();
      return result;
    },
  });
};

export const useGetPayments = () => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["payments"],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/payment`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
          Authorization: authString,
        },
      });

      return result;
    },
  });
};

export const useMakePayment = () => {
  const { refetch } = useGetPayments();
  const { user } = useAuth() as AuthContextValue;

  return useMutation({
    mutationFn: async (
      data: {
        redemptionId: number;
        txnNo: string;
        redemptionCode: string;
        saveStatus: boolean;
      }[]
    ) => {
      const result = await axiosBaseURL.post(`/payment/create`, data, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });
      refetch();
      return result;
    },
  });
};
